var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.3,
    d: "M6.916 6l3.894-3.894c.253-.253.253-.663 0-.916s-.663-.253-.916 0L6 5.084 2.106 1.19c-.253-.253-.663-.253-.916 0s-.253.663 0 .916L5.084 6 1.19 9.894c-.253.253-.253.663 0 .916.126.126.292.19.458.19.166 0 .332-.064.458-.19L6 6.916l3.894 3.894c.126.126.292.19.458.19.166 0 .332-.064.458-.19.253-.253.253-.663 0-.916L6.916 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3b52a62c566347cf65722e2349c48ac8.svg";
export { ForwardRef as ReactComponent };